import { toastSuccess } from '../../../functions/toast/toast.js';
import { getStore } from '../../helpers/initStore.js';

const cancelledOrderToast = () => {
    toastSuccess('Order canceled successfully');
};
const removeOrderFromCurrentList = (orderID) => {
    const store = getStore();
    store.commit('office/UNSET_OFFICE_ORDER', orderID);
};

export { cancelledOrderToast, removeOrderFromCurrentList };
